var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardAsAlert',{staticClass:"card_color_success",attrs:{"imageName":"welcome.svg"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Добро пожаловать в личный кабинет")]},proxy:true},{key:"message",fn:function(){return [_vm._v("Для начала работы необходимо выбрать договор")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }